import { Box, Typography } from '@mui/material';
import { SubmitHandler, useForm } from 'react-hook-form';
import { BigButton } from '../common/Buttons/BigButton';
import { TextInput } from '../common/TextInput';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Link from 'components/Link';
import { useState } from 'react';
import { ApiPostNoAuth } from 'helpers/Api/ApiData';
import { toast, ToastContainer } from 'react-toastify';

export default function ForgotPassword() {
  const [emailSent, setEmailSent] = useState<boolean>(false);

  const onSubmit: SubmitHandler<{ email: string }> = (data) => {
    // setLoader(true);
    ApiPostNoAuth(`user/forgot-password`, data)
      .then((res: any) => {
        if (res.data.statusCode === 200) {
          // router.push('/reset-password');
          // toast.success(res.data.message, { autoClose: 5000 ,hideProgressBar: true });
          // setLoader(false);
          setEmailSent(true);
        } else {
          toast.error(res?.data?.message || 'Please try again!!', {
            autoClose: 5000,
            hideProgressBar: true,
          });
          // setLoader(false);
        }
      })
      .catch((err) => {
        toast.error(err.message, { autoClose: 5000, hideProgressBar: true });
        // setLoader(false);
      });
  };

  const schema = yup.object().shape({
    email: yup
      .string()
      .email('Please enter valid email address')
      .required('Email is required'),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onTouched',
  });

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)}>
      <ToastContainer />
      <Typography
        component="h1"
        fontWeight={700}
        fontSize={28}
        lineHeight="32.81px"
        mt="42px"
      >
        Forgot Password
      </Typography>
      <Typography
        fontWeight={500}
        color="rgba(0, 0, 0, 0.67)"
        fontSize={14}
        lineHeight="21px"
        mt="60px"
        mb={3}
      >
        Enter your registered Email ID to reset your password
      </Typography>
      <TextInput
        type="email"
        placeholder="example@gmail.com"
        register={register('email')}
        errorMessage={errors.referrer_code?.message}
      />

      <Box color="rgba(0, 0, 0, 0.67)">
        <Typography
          fontSize={14}
          fontWeight={500}
          lineHeight="21px"
          // display={emailSent ? 'block' : 'hidden'}
          visibility={emailSent ? 'inherit' : 'hidden'}
        >
          Reset password link has been sent to your email. Please check your
          inbox.
        </Typography>
        <Typography
          fontSize={12}
          fontWeight={300}
          mt={8}
          lineHeight="21px"
          visibility={emailSent ? 'inherit' : 'hidden'}
        >
          Note: If the reset password email missed your Inbox, make sure you
          check your Spam and Bulk folders too.
        </Typography>
      </Box>
      {emailSent ? null : (
        <>
          <BigButton
            // onClick={handleSubmit(onSubmit)}
            type="submit"
            sx={{ py: '10px', width: '100%', mt: 3 }}
          >
            <Typography fontWeight={700} fontSize={18}>
              CONFIRM
            </Typography>
          </BigButton>
          <Typography align="center" mt={3} mb={3}>
            <Link
              href="/login"
              noLinkStyle
              sx={{ color: '#646464', fontSize: 12 }}
            >
              Cancel
            </Link>
          </Typography>
        </>
      )}
    </Box>
  );
}
